import { Row, Container } from 'reactstrap';
import AssignedTableWrapper from './table/AssignedTableWrapper';

const AssignedCard = () => {
  return (
    <Container>
      <Row>
        <AssignedTableWrapper />
      </Row>
    </Container>
  );
};

export default AssignedCard;
